import { IconTextIncrease } from '@tabler/icons-react'

import { RichTextDisplayBlock as RenderRichTextDisplayBlock } from '../../templateRenderer/DisplayBlocks/RichTextDisplayBlock'
import { RichTextDisplayBlock } from '../../types/blueprint'

import {
  BaseBlockConfig,
  Field,
  RichTextField,
  TypeOption,
} from './_BaseBlockConfig'

class Config extends BaseBlockConfig<RichTextDisplayBlock> {
  public override kind = 'display' as const
  public override type = 'richText' as const

  public override blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'Formatted body text',
    icon: IconTextIncrease,
    hideName: true,
    hideDescription: true,
  }

  public override blockFieldsConfig: Field[] = [
    {
      name: 'content',
      label: 'Text value',
      field: RichTextField,
      required: true,
    },
  ]

  public override mapFormValueToBlock(
    block: RichTextDisplayBlock
  ): RichTextDisplayBlock {
    return block
  }

  public override renderBlock(block: RichTextDisplayBlock): React.ReactNode {
    return <RenderRichTextDisplayBlock block={block} />
  }
}

export const RichTextDisplayBlockConfig = new Config()
